import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import localizedFormat from "dayjs/plugin/localizedFormat";
import updateLocale from "dayjs/plugin/updateLocale";
import { Locales } from "../strings/Locales.js";
import { MissingFormatWithOptions } from "./internal/MissingFormat.js";
import { TemporalUtils } from "./internal/TemporalUtils.js";
// required for `calendar` to work
dayjs.extend(calendar);
// required for `updateLocale` to work
dayjs.extend(updateLocale);
// required for ll and LLL to work
dayjs.extend(localizedFormat);
dayjs.updateLocale("en", {
    calendar: {
        sameElse: function sameElse(now) {
            return now.diff(this, "months") > 6 ? this.format(Locales.format("otherCalendarDateShort", {
                date: "ll"
            })) : this.format(Locales.format("otherCalendarDateLong", {
                date: "ll",
                time: "LT"
            }));
        }
    }
});
export var DayjsCalendarTimeFormat = /*#__PURE__*/ function() {
    "use strict";
    function DayjsCalendarTimeFormat() {
        _class_call_check(this, DayjsCalendarTimeFormat);
    }
    var _proto = DayjsCalendarTimeFormat.prototype;
    _proto.format = function format(value) {
        return TemporalUtils.toDayjs(value).calendar();
    };
    _proto.resolvedOptions = function resolvedOptions() {
        return {
            locale: dayjs.locale()
        };
    };
    return DayjsCalendarTimeFormat;
}();
export var DayjsCalendarTimeMissingFormat = /*#__PURE__*/ function(MissingFormatWithOptions) {
    "use strict";
    _inherits(DayjsCalendarTimeMissingFormat, MissingFormatWithOptions);
    var _super = _create_super(DayjsCalendarTimeMissingFormat);
    function DayjsCalendarTimeMissingFormat(options) {
        _class_call_check(this, DayjsCalendarTimeMissingFormat);
        return _super.call(this, new DayjsCalendarTimeFormat(), options);
    }
    return DayjsCalendarTimeMissingFormat;
}(MissingFormatWithOptions);

//# sourceMappingURL=DayjsCalendarTimeMissingFormat.js.map